// autogenerated, do not modify

export default {
  "ActivationCode.AlreadyHasCards": "It looks like you already have an account. Please login",
  "ActivationCode.ButtonText": "Далее",
  "ActivationCode.FieldsAreRequired": "Пожалуйста, заполните форму",
  "ActivationCode.FindActivationCode": "Код активации расположен на обратной стороне карты MTXC:",
  "ActivationCode.Header": "Код активации",
  "ActivationCode.Placeholder": "Введите код активации",
  "ActivationCode.WrongFormat": "Код активации введен неверно",
  "Axios.ConnectionError": "Нет соединения с сетью. Пожалуйста, проверьте подключение и настройку точки доступа в Интернет (APN: “internet”).",
  "Axios.Error": "Ошибка {status}",
  "Axios.ServerError": "Что-то пошло не так. Мы уже работаем над исправлением, попробуйте ещё раз.",
  "Axios.TimeoutError": "Время ожидания истекло. Пожалуйста, попробуйте еще раз.",
  "Common.ActivationCode": "Код активации",
  "Common.Back": "Назад",
  "Common.Email": "Email",
  "Common.Name": "Имя",
  "Common.Next": "Далее",
  "Common.Password": "Пароль",
  "Common.Phone": "Телефон",
  "Common.SIM": "SIM",
  "Confirmation.ActivateMySim": "Активировать SIM-карту",
  "Confirmation.Header": "Пожалуйста, подтвердите информацию",
  "ForgotPassword.BackToLogin": "Вернуться к форме входа",
  "ForgotPassword.ButtonText": "Выслать код подтверждения",
  "ForgotPassword.ChangePassword": "Задать новый пароль",
  "ForgotPassword.CheckYourEmailOrPhone": "Пароль был выслан на почту",
  "ForgotPassword.CheckYourPhone": "Пароль был выслан на телефон",
  "ForgotPassword.EnterEmailOrPhone": "Введите свой Email, указанный при регистрации",
  "ForgotPassword.EnterNewPassword": "Пожалуйста, укажите новый пароль",
  "ForgotPassword.EnterPhone": "Введите свой телефон, указанный при регистрации",
  "ForgotPassword.Header": "Восстановление пароля",
  "ForgotPassword.NewPassword": "Новый пароль",
  "ForgotPassword.NewPasswordConfirmation": "Подтвердите пароль",
  "ForgotPassword.PasswordAreTooWeak": "Пароль слишком слабый. Пожалуйста, придумайте более надежный пароль!",
  "ForgotPassword.PasswordChanged": "Пароль успешно изменён.",
  "ForgotPassword.PasswordsDoesNotMatch": "Пароли не совпадают!",
  "ForgotPassword.RecoveryTokenInvalid": "Ваша ссылка для восстановления пароля устарела. Пожалуйста, восстановите пароль ещё раз.",
  "ForgotPassword.ScoreWord-good": "Хороший",
  "ForgotPassword.ScoreWord-okay": "Нормальный",
  "ForgotPassword.ScoreWord-strong": "Надёжный",
  "ForgotPassword.ScoreWord-stronger": "Сильный",
  "ForgotPassword.ScoreWord-weak": "Слабый",
  "ForgotPassword.TryAgain": "Восстановить пароль",
  "ForgotPassword.UnableToChangePassword": "Не получилось сменить пароль! Пожалуйста, попробуйте еще раз!",
  "Login.ActivateCard": "Активировать новую карту",
  "Login.AlreadyHaveAccount": "У вас уже есть аккаунт. Пожалуйста, залогиньтесь.",
  "Login.ForgotPassword": "Забыли пароль?",
  "Login.Header": "Вход",
  "Login.Login": "Войти",
  "Login.Or": "или",
  "Login.Signup": "Регистрация",
  "Login.TryLogin": "Авторизуйтесь, если у вас есть аккаунт или зарегистрируйте новый.",
  "Menu.ContactUs": "Контакты",
  "Menu.Coverage": "Карта покрытия",
  "Menu.Faq": "Поддержка",
  "Menu.HowItWorks": "Как это работает",
  "Menu.Pricing": "Тарифы",
  "Register.AlreadyHaveAccount": "У меня уже есть аккаунт",
  "Register.ButtonText": "Регистрация",
  "Register.ChooseFile": "Загрузить файл",
  "Register.ConfirmEmail": "Подтвердите email",
  "Register.ConfirmPassword": "Подтвердите пароль",
  "Register.ConfirmPhone": "Подтвердите телефон",
  "Register.Country": "Страна",
  "Register.Email": "Email",
  "Register.EmailWrongFormat": "Email не корректен",
  "Register.EmailsDontMatch": "Email-ы не совпадают",
  "Register.FirstName": "Имя",
  "Register.FirstNameHint": null,
  "Register.Header": "Пожалуйста, предоставьте информацию о себе",
  "Register.IdentityHint": "(Можно сделать позже)",
  "Register.LastName": "Фамилия",
  "Register.LastNameHint": null,
  "Register.NonLatinError": "Используйте только латинские буквы, цифры и знаки препинания",
  "Register.Password": "Пароль",
  "Register.PasswordsDontMatch": "Пароли не совпадают",
  "Register.Phone": "Телефон",
  "Register.PhoneHint": null,
  "Register.PhonesDontMatch": "Телефоны не совпадают",
  "Register.ShortPassword": "Пароль должен состоять минимум из 6 символов",
  "Register.ShouldAgreeWithTerms": "Для регистрации требуется согласие с условиями",
  "Register.TermsAndConditions": "Чтобы продолжить, Вы должны прочитать и согласиться с условиями MTX Connect",
  "Register.UploadIdentity": "Загрузить скан документа",
  "Register.UploadWrongFormat": "Файл должен быть в формате jpg",
  "Register.countryEmpty": "Укажите страну",
  "Register.emailEmpty": "Укажите email",
  "Register.firstNameEmpty": "Укажите имя",
  "Register.lastNameEmpty": "Укажите фамилию",
  "Register.passwordEmpty": "Задайте пароль",
  "Register.phoneEmpty": "Укажите телефон",
  "Shared.ErrorPhoneMsg": "Используйте только латинские буквы, цифры и знаки препинания",
  "Verify.Title": "Спасибо! Ваш адрес электронной почты подтвержден.",
}



// WEBPACK FOOTER //
// ./app/javascript/components/application/locales/ru.js